import {MessagingRole} from 'Users/models/User/MessagingUserType';

export class MessageAnalystUserType {
  public readonly key = 'MessageAnalystUserType';
  public readonly messagingRole = MessagingRole.MessageAnalyst;
}
